// @ts-nocheck
import { Navigate } from "react-router-dom"
import { BookmarksClient } from "@/components/dashboard/BookmarksClient"
import { useAuth } from "@/components/layout/AuthProvider"

export default function BookmarksPage() {
  const { supabaseUser } = useAuth()
  if (!supabaseUser) return <Navigate to="/auth/login" replace />
  return <div className="container-narrow py-4"><BookmarksClient userId={supabaseUser.id} /></div>
}